import MyobSyncCompanyFileHtml from '../myob/myob.sync-company-file.html';

export function AccountingIntegrationCtrl ($uibModal, $scope, $translate, adminDashboardApi, confirm, messages, workshopAPI) {

  $scope.changeAccountingIntegration = function () {
    adminDashboardApi.changeAccountingIntegration($scope.company)
    .then(() => messages.show($translate.instant('JS_SPACE.MESSAGES.ACCOUNTING_CHANGES'), 'success'))
    .catch(error => messages.error(error));
  };

  $scope.resetXero = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.RESET_TO_INITIAL_SYNC_STATE', {name:"Xero"})).then(function () {
      workshopAPI.get('/workshop_admin/reset_xero_sync', $scope.company.id).then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.XERO_RESET'), 'success');
      }, function (err) {
        messages.error(err);
      });
    });
  };

  $scope.resetMyob = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.RESET_TO_INITIAL_SYNC_STATE', {name:"MYOB"})).then(function () {
      workshopAPI.get('/workshop_admin/reset_myob_sync', $scope.company.id).then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.MYOB_RESET'), 'success');
      }, function (err) {
        messages.error(err);
      });
    });
  };

  $scope.resetQBO = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.RESET_TO_INITIAL_SYNC_STATE', {
      name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE')
    }))
    .then(() => {
      workshopAPI.get('/workshop_admin/reset_qbo_sync', $scope.company.id)
      .then(() => {
        messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE_RESET'), 'success');
      })
      .catch(err => {
        messages.error(err);
      });
    });
  };

  $scope.syncMyobFile = function () {
    $uibModal.open({
      templateUrl: MyobSyncCompanyFileHtml,
      controller : 'SyncMyobCompanyFileCtrl',
      resolve    : {
        company: [ function () {
          return $scope.company;
        }]
      }
    }).result.then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MYOB_COMPANY_FILE_SYNCED'), 'success');
    });
  };
}